'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _customersDataActions = require('actions/customersDataActions');

var _requirementDataActions = require('actions/requirementDataActions');

var _utilityFunctions = require('utils/utilityFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We require name and birthday data to be shown for each customer
// If we can get this from requirements and save a call to the API for `customers`, then do it
// Must then update this name data on new requirement fetches
var reqCodesToExtract = ['NAME', 'DATE_OF_BIRTH', 'EMAIL_ADDRESS'];
var mergeInExtractedCustomersNameData = function mergeInExtractedCustomersNameData(oldCustomersById, requirementsByHash) {
    var newCustomersByIdObj = (0, _extends3.default)({}, oldCustomersById);
    (0, _keys2.default)(requirementsByHash).forEach(function (requirementHash) {
        var requirement = requirementsByHash[requirementHash];
        if (reqCodesToExtract.includes(requirement.code)) {
            var props = requirement.fieldValuesByResourceType.customers;
            (0, _keys2.default)(props).forEach(function (propPathString) {
                var propValue = props[propPathString].value;
                newCustomersByIdObj[requirement.customer] = (0, _utilityFunctions.setResourceValue)(propPathString, newCustomersByIdObj[requirement.customer], propValue);
            });
        }
    });
    // Add ids to each customer and return
    return (0, _keys2.default)(newCustomersByIdObj).reduce(function (obj, customerId) {
        obj[customerId].id = customerId;
        return obj;
    }, newCustomersByIdObj);
};

// customer resources are stored by id
function customers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _requirementDataActions.REQUIREMENT_DATA_RECEIVED:
            return mergeInExtractedCustomersNameData(state, action.requirementData.requirements);
        case _customersDataActions.CUSTOMERS_DATA_RECEIVED:
            return (0, _extends3.default)({}, state, (0, _utilityFunctions.reduceResourceArrayToObjById)(action.newCustomersData, 'id'));
        default:
            return state;
    }
}

exports.default = customers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/customers.js
// module id = 1396
// module chunks = 0